import { allCompaniesFlows } from '../../constants/general/allCompaniesFlows';
import type { AllCompaniesFlows, AllCompaniesNames } from '../../types/general';

export const isValidFlowName = (
  company: AllCompaniesNames,
  flow: string,
): flow is keyof AllCompaniesFlows[typeof company] => flow in allCompaniesFlows[company];
